module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"SearchInput":{"ariaLabel":"Vyhledávání","button":"Hledat","placeholder":"Co hledáte? Např. LED světla?"}},"en":{"SearchInput":{"ariaLabel":"Searching","button":"Search","placeholder":"Search"}}}')
  delete Component.options._Ctor
}
